import React, { useCallback, useEffect, useState } from "react";
import { Container } from "reactstrap";

import Columns from "./Columns";
import AddUpdModal from "./AddUpdModal";
import { DestroyAlertHelper } from "../../helpers/alerts/alertHelper";
import DataTableHelper from "../../helpers/tables/DataTableHelper";
import { delPlan, getCompanies, getPlans } from "../../helpers/backend_helper";

const initPlan = {
  name: "",
};

const Plans = () => {
  const [items, setItems] = useState([]);
  const [dataPag, setDataPag] = useState({});
  const [plan, setPlan] = useState(initPlan);
  const [pending, setPending] = useState(false);
  const [modal, setModal] = useState({ show: false, update: false });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
  });

  const fetchPlans = useCallback((filters) => {
    const config = { params: filters };
    setPending(true);

    getPlans(config)
      .then((response) => {
        setItems(response.plans.data);
        setDataPag(response.plans);
      })
      .finally(() => {
        setPending(false);
      });
  }, []);

  const onFinishModalAction = () => {
    fetchPlans(filters);
  };

  useEffect(() => fetchPlans(filters), [filters, fetchPlans]);

  const addUpd = (row = false) => {
    setPlan(row);

    if (row.id) {
      setModal({ ...modal, show: true, update: true });
      return;
    }

    setModal({ ...modal, show: true, update: false });
  };

  const destroy = async (id) => {
    DestroyAlertHelper(async (confirmed) => {
      if (!confirmed) return;

      await delPlan(id);
      onFinishModalAction();
      //Alert(response.message, response.status);
    });
  };

  const columns = Columns(addUpd, destroy);
  document.title = "Planes | Sistema de logística";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle="Planes"
              columns={columns}
              items={items}
              pending={pending}
              getCompanies={getCompanies}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
            >
              <div
                className="ms-auto float-end ms-2"
                style={{ maxWidth: "120px" }}
              >
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => addUpd(initPlan)}
                >
                  <i className="fas fa-solid fa-plus"></i> Agregar
                </button>
              </div>
            </DataTableHelper>
          </div>
        </Container>
        {modal.show && (
          <AddUpdModal
            modal={modal}
            setModal={setModal}
            plan={plan}
            setPlan={setPlan}
            onFinishModalAction={onFinishModalAction}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default Plans;
